import { render, staticRenderFns } from "./cabinet-notice-card-row-dual.vue?vue&type=template&id=052f315c&"
import script from "./cabinet-notice-card-row-dual.vue?vue&type=script&lang=js&"
export * from "./cabinet-notice-card-row-dual.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev2/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('052f315c')) {
      api.createRecord('052f315c', component.options)
    } else {
      api.reload('052f315c', component.options)
    }
    module.hot.accept("./cabinet-notice-card-row-dual.vue?vue&type=template&id=052f315c&", function () {
      api.rerender('052f315c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/cabinet/partials/cabinet-notice-card-row-dual.vue"
export default component.exports